import React from "react";
import { makeData } from "../../../../data/category/inputData";
import FilterTitle from "../Common/FilterTitle";
import Text from "../Common/Text";
import ViewMore from "../Common/ViewMore";

const Make = () => {
  return (
    <div className="border-b border-darkGreen border-opacity-40 px-2 py-8">
      <FilterTitle title={"Make"} />
      <div className="mb-2 flex flex-col gap-2">
        {makeData.map((make) => (
          <Text key={make.id} text={make.name} amount={make.amount} />
        ))}
      </div>
      <ViewMore />
    </div>
  );
};

export default Make;
